import axios from "axios";

// 1. MAP TYPE TO MODEL STRING
const mapPromptTypeToModel = (promptType) => {
  if (promptType === "day") {
    return "day-by-day"; // 👈 Exactly what the API expects
  }
  return "Overall";
};

export const fetchAiAdsInsight = async (question, promptType) => {
  const model = mapPromptTypeToModel(promptType);

  try {
    const response = await axios.post(
      "http://127.0.0.1:5001/confi-ai-20e6e/us-central1/aiAdsAssistant",
      {
        question: question,
        adsPayload: {
          email: localStorage.getItem("email"),
          customer_id: localStorage.getItem("customer_id"),
          project_id: Number(localStorage.getItem("project_id")),
          model: model, // 👈 Passing the correct model here
        },
      }
    );

    const data = response.data;

    if (!Array.isArray(data) || data.length === 0) {
      return { type: "text", content: "No data found for this period." };
    }

    // Return Data + The Type so Frontend knows how to render
    return { 
      type: "data_viz", 
      vizType: promptType, // 'day' or 'overall'
      data: data 
    };

  } catch (error) {
    console.error("API Error:", error);
    return { type: "text", content: "Sorry, I couldn't fetch the ads data right now." };
  }
};